<template>
  <div>
    <v-card>
      <v-toolbar
        dark
        flat
      >
        <v-icon
          left
        >
          edit
        </v-icon>
        {{ edituser.id ? 'Edit' : 'Create New' }} User
        <v-spacer />
        <v-fade-transition>
          <div
            v-if="showCardActions"
          >
            <v-btn
              :disabled="saving"
              flat
              color="gray"
              @click="closeDialog">
              Cancel
            </v-btn>
            <v-btn
              :disabled="saving"
              color="blue"
              @click="save(edituser)">
              Save
            </v-btn>
          </div>
        </v-fade-transition>
      </v-toolbar>
      <Preloader v-if="loading"/>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          style="text-align:center;display: flex;background-color: #F5F5F5;padding: 20px;align-items: center;"
        >
          <v-icon
            size="155"
            color="grey"
            style="margin-right: 20px;"
          >
            account_circle
          </v-icon>
          <div
            style="text-align:left;flex-grow: 1;"
            class="details"
          >
            <span style="font-size:24px;">{{ edituser.first_name }} {{ edituser.last_name }}</span><br />
            <div
              style="margin-bottom: 5px;"
            >
              <v-chip
                label
                :color="edituser.is_active ? 'green lighten-3' : 'red lighten-3'"
              >
                {{ edituser.is_active ? 'Enabled' : 'Disabled' }}
              </v-chip>
              <v-chip
                v-if="edituser.is_org_admin"
                label
                color="blue"
                dark
              >
                Organization Admin
              </v-chip>
              <v-chip
                v-if="edituser.has_api_token"
                label
                color="#262626"
                dark
              >
                API Token Active
              </v-chip>
              <v-chip
                v-if="edituser.id == currentUserId"
                label
                color="green"
                dark
              >
                This is you!
              </v-chip>
            </div>
            <span><b>Username: </b>{{edituser.username}}</span><br />
            <span><b>E-mail: </b>{{edituser.email}}</span><br />
            <span><b>Date Created: </b>{{edituser.id ? edituser.date_joined : 'In a moment...'}}</span><br />
            <span><b>Last Login: </b>{{edituser.id ? edituser.last_login || 'Never' : 'Never'}}</span>
          </div>
          <div
            style="display: flex;flex-direction: column;"
          >
            <v-btn
              v-if="edituser.id"
              color="#FFEA00"
              @click="passwordReset=true"
            >
              Reset Password
            </v-btn>
            <v-btn
              v-if="edituser.id"
              @click="apiTokenCheck()"
              style="margin-top: 10px; margin-right: 5px"
            >
              Get API Token
            </v-btn>
            <v-btn
              v-if="edituser.id"
              @click="showForceLogoutDialog = true"
              style="margin-top: 10px; margin-right: 5px"
              color="red"
              dark
            >
              End All Sessions
            </v-btn>
            
          </div>
        </v-flex>
        <v-flex
          xs12
        >
          <v-expand-transition>
            <v-tabs
              v-if="user"
              v-model="tabs"
              slider-color="primary"
              color="transparent"
              style="max-height: 100%;"
            >
              <v-tab
                key="settings"
              >
                Settings
              </v-tab>
              <v-tab
                key="audit"
              >
                Audit Log
              </v-tab>
              <v-tab
                key="sessions"
              >
                Sessions
              </v-tab>
            </v-tabs>
          </v-expand-transition>
          <v-fade-transition>
            <v-tabs-items
              v-model="tabs"
            >
              <v-tab-item
                key="settings"
              >
              <v-form ref="editForm">
                <v-container fluid>
                <v-card
                  style="margin:15px;"
                >
                  <v-toolbar
                    flat
                    dense
                  >
                    Account Information
                  </v-toolbar>
                  <v-card-text>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs6>
                        <v-text-field
                          v-model="edituser.first_name"
                          autofocus
                          label="First Name"
                        />
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="edituser.last_name"
                          label="Last Name"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex>
                      <v-text-field
                        v-model="edituser.username"
                        :error-messages="errorMessages['username']"
                        :rules="[v => !!v || 'Username is required']"
                        label="Username"
                      />
                      </v-flex>
                    </v-layout>
                    <v-text-field
                      v-model="edituser.email"
                      :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid']"
                      label="E-mail"
                    />
                    <v-text-field
                      v-model="edituser.phone"
                      :rules="edituser.phone ? [v => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v) || 'Phone Number must match ###-###-####, ##########, ### ### #### or any equivalent format'] : []"
                      label="Mobile Phone"
                    />
                  </v-card-text>
                </v-card>
                <v-card
                  style="margin:15px;"
                >
                  <v-toolbar
                    flat
                    dense
                  >
                    Security
                  </v-toolbar>
                  <v-card-text
                    style="padding-top: 0;margin-top:0;"
                  >
                    <v-switch
                      v-model="edituser.is_active"
                      hide-details
                      :label="`Enabled`"
                    ></v-switch>
                    <v-switch
                      v-model="edituser.is_org_admin"
                      messages="This grants a user access to your organization branding and user management."
                      :label="`Organization Administrator`"
                    ></v-switch>
                    <v-expand-transition>
                      <v-alert
                        v-if="edituser.role == null && !edituser.is_org_admin"
                        :value="true"
                        type="warning"
                        outline
                        style="margin-top: 15px;"
                      >
                        Users without a Role have No Access. Set a role to define the user's permissions.
                      </v-alert>
                    </v-expand-transition>
                    <v-autocomplete
                      v-model="edituser.role"
                      :disabled="edituser.is_org_admin"
                      :items="roles"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="roleSearch"
                      label="Role"
                      cache-items
                      clearable
                      persistent-hint
                      :hint="edituser.is_org_admin ? 'To set a user role, disable admin permissions' : 'Set a role to define user permissions'"
                    />
                    <v-autocomplete
                      v-model="edituser.group"
                      :disabled="edituser.is_org_admin"
                      :items="groups"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="groupSearch"
                      label="Security Group"
                      cache-items
                      clearable
                      persistent-hint
                      :hint="edituser.is_org_admin ? 'To set a security group, you disable admin permissions.' : 'Set a security group to limit this user to specific case types'"
                    />
                  </v-card-text>
                </v-card>
                <v-card
                  v-if="edituser.id"
                  style="margin:15px;"
                >
                  <v-toolbar
                    flat
                    dense
                  >
                    Notification Preferences
                    <span style="font-weight:700;">
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span v-if="tagStatus === 'saving'">
                        Saving Preferences...
                      </span>
                      <span v-if="tagStatus === 'saved'">
                        Preferences Saved!
                      </span>
                      <span v-if="tagStatus === 'error'">
                        !! Something went wrong !!
                      </span>
                    </span>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm4>
                        <span>How would you like to receive notifications?</span>
                      </v-flex>
                      <v-flex xs12 sm4>
                        <v-switch
                          v-model="edituser.notify_by_email"
                          style="display:inline;text-align:center;"
                          label="Via E-mail"
                          :hint="edituser.email"
                          persistent-hint
                        ></v-switch>
                      </v-flex>
                      <v-flex xs12 sm4>
                      <!--
                        <v-switch
                          v-model="edituser.notify_by_phone"
                          style="display:inline;"
                          label="Via SMS"
                          :hint="edituser.phone"
                          persistent-hint
                        ></v-switch>
                      -->
                      </v-flex>
                    </v-layout>
                    <br />
                    <hr />
                    <br />
                    <p style="font-weight:500;font-size:18px;">Form Subscriptions</p>
                    <div
                      v-for="tag in formTagSubs"
                      :key="tag.slug"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm3>
                          <v-chip
                            label
                            small
                          >
                            {{tag.tag}}
                          </v-chip>
                          <span>
                            <v-icon
                              small
                              right
                              @click="deleteFormSub(tag)"
                            >
                              delete_forever
                            </v-icon>
                          </span>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_start"
                            style="display:inline;"
                            label="On Client Start"
                            @change="updateFormTag(tag)"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_submit"
                            style="display:inline;"
                            label="On Client Submission"
                            @change="updateFormTag(tag)"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm3>
                          <v-switch
                            v-model="tag.on_client_sign"
                            style="display:inline;"
                            label="On Client Signing"
                            @change="updateFormTag(tag)"
                          ></v-switch>
                        </v-flex>
                      </v-layout>
                    </div>
                    <v-btn
                      small
                      v-if="!addFormTag"
                      @click="addFormTag = true"
                    >
                      <v-icon small left>add</v-icon>
                      Add Form Subscription
                    </v-btn>
                    <v-expand-transition>
                      <div v-if="addFormTag">
                        <v-autocomplete
                          v-model="filterFormTags"
                          :items="tagFormResults"
                          :search-input.sync="tagFormSearch"
                          label="Search for a Tag"
                          dense
                          return-object
                          item-text="tag"
                          auto-select-first
                          hide-details
                        />
                      </div>
                    </v-expand-transition>
                    <br />
                    <br />
                    <p style="font-weight:500;font-size:18px;">Contact Subscriptions</p>
                    <div
                      v-for="tag in contactTagSubs"
                      :key="tag.slug"
                    >
                      <v-layout row wrap>
                        <v-flex xs12 sm4>
                          <v-chip
                            label
                            small
                          >
                            {{tag.tag}}
                          </v-chip>
                          <span>
                            <v-icon
                              small
                              right
                              @click="deleteContactSub(tag)"
                            >
                              delete_forever
                            </v-icon>
                          </span>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-switch
                            v-model="tag.on_client_file_upload"
                            style="display:inline;"
                            label="On Client File Upload"
                            @change="updateContactTag(tag)"
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm4>
                          <v-switch
                            v-model="tag.on_client_message"
                            style="display:inline;"
                            label="On Client Communication"
                            @change="updateContactTag(tag)"
                          ></v-switch>
                        </v-flex>
                      </v-layout>
                    </div>
                    <v-btn
                      small
                      v-if="!addContactTag"
                      @click="addContactTag = true"
                    >
                      <v-icon small left>add</v-icon>
                      Add Contact Subscription
                    </v-btn>
                    <v-expand-transition>
                      <div v-if="addContactTag">
                        <v-autocomplete
                          v-model="filterContactTags"
                          :items="tagContactResults"
                          :search-input.sync="tagContactSearch"
                          label="Search for a Tag"
                          dense
                          return-object
                          item-text="tag"
                          auto-select-first
                          hide-details
                        />
                      </div>
                    </v-expand-transition>
                  </v-card-text>
                </v-card>
                <v-card
                  v-if="!edituser.id && editing"
                  style="margin:15px;"
                >
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex>
                        <v-text-field
                          v-model="edituser.password"
                          :error-messages="errorMessages['password']"
                          :rules="[v => !!v || 'Password is required']"
                          type="password"
                          label="Temporary Password"
                          autocomplete="new-password"
                        />
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-form>
              </v-tab-item>
              <v-tab-item
                key="audit"
                v-if="user"
              >
                <UserActivityLog
                  v-if="tabs == 1"
                  :user="user"
                />
              </v-tab-item>
              <v-tab-item
                key="sessions"
                v-if="user"
              >
                <UserSessionLog
                  v-if="tabs == 2"
                  :user="user"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-fade-transition>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog
      v-model="passwordReset"
      width="600"
      transition="dialog-fade-transition"
    >
      <v-card
        style="background: #FAFAFA; color: black;"
      >
        <v-card-text
          v-if="!passwordSaved"
          style="text-align:left;"
        >
          <v-alert
            :value="true"
            type="warning"
          >
            Resetting {{ edituser.first_name || edituser.username }}'s password will log them out of all active sessions.
          </v-alert>
          <v-alert
            v-if="edituser.has_api_token"
            :value="true"
            type="error"
            style="text-align:left;"
          >
            {{ edituser.first_name || edituser.username }} has an active API token. Resetting their password will also invalidate their current API token.
          </v-alert>
          <div>
            <v-text-field
              v-model="newPassword"
              label="New Temporary Password"
              hint="Leave blank to generate a random password"
              persistent-hint
            />
          </div>
        </v-card-text>
        <v-card-text
          v-else
          style="text-align:center;"
        >
          <v-icon
            color="green"
            size="92"
            style="margin-bottom: 15px;"
          >
            mdi-lock-reset
          </v-icon>
          <div>
            {{ edituser.first_name || edituser.username }}'s password has been reset, and they have been logged out of all active sessions.<br /><br />
            Their new temporary password is:<br />
            <code style="font-size:18px;">{{ newPassword }}</code><br /><br />
            Make sure to copy this password now, as it will not be shown again. {{ edituser.first_name || edituser.username }} will be prompted to change their password upon next login.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="white"
            @click="passwordReset = false;newPassword = null;passwordSaved = false"
          >
            {{ passwordSaved ? 'Close' : 'Cancel' }}
          </v-btn>
          <v-spacer />
          <span
            v-if="!passwordSaved"
          >
            <v-btn
              v-if="newPassword == null || newPassword.length == 0"
              color="red"
              dark
              @click="resetPassword()"
            >
              Generate Random Password
            </v-btn>
            <v-btn
              v-else
              color="blue"
              dark
              @click="resetPassword()"
            >
              Set Password
            </v-btn>
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showTokenDialog"
      width="500"
      transition="dialog-fade-transition"
    >
      <v-card
        style="text-align:center;"
      >
        <v-card-text
          style="text-align:center;"
        >
          <v-icon
            color="green"
            size="92"
            style="margin-bottom: 15px;"
          >
            mdi-script-text-key
          </v-icon>
          <div>
            {{ edituser.first_name || edituser.username }}'s new API token is:<br />
            <code style="font-size:18px;">{{ APIToken }}</code><br /><br />
            Treat this token like a password, as it provides access to {{ app_name }} via the API with all permissions granted to {{ edituser.first_name || edituser.username }}.<br /><br />
            Make sure to copy this token now, as it will not be shown again.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="showTokenDialog = false"
          >
            OK
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showForceLogoutDialog"
      width="600"
      transition="dialog-fade-transition"
    >
      <v-card
        style="background: #FAFAFA; color: black;"
      >
        <v-card-text
          style="text-align:center;"
        >
          <v-icon
            color="#F44336"
            size="92"
            style="margin-bottom: 15px;"
          >
            mdi-alert-octagon
          </v-icon>
          <div
            v-if="edituser.id == currentUserId"
          >
            You are about to log yourself out of all other sessions.<br /><br /><b>The session you're currently using will not be logged out.</b><br /><br />
            If you suspect any unauthorized access to your account, it is recommended to also reset your password.
          </div>
          <div
            v-else
          >
            <b>This will immediately log the user out of all active sessions, including their current one. They will need to log back in to continue using {{ app_name }}.</b><br /><br />
            If you suspect any unauthorized access to this account, it is recommended to also reset the user's password.
          </div>
          <v-alert
            v-if="edituser.has_api_token"
            :value="true"
            type="error"
            style="text-align:left;margin-top: 15px;"
          >
            {{ edituser.first_name || edituser.username }} has an active API token. Ending all sessions will also invalidate their current API token.
          </v-alert>
        </v-card-text>
        <v-card-actions
          style="background: #F44336; color: white;"
        >
          <v-btn
            dark
            small
            flat
            @click="forceLogout();showForceLogoutDialog = false"
          >
            Log {{ edituser.first_name }} Out of All Sessions
          </v-btn>
          <v-spacer />
          <v-btn
            color="white"
            @click="showForceLogoutDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="resetAPITokenDialog"
      width="600"
      transition="dialog-fade-transition"
    >
      <v-card
        style="background: #FAFAFA; color: black;"
      >
        <v-card-text
          style="text-align:center;"
        >
          <v-icon
            color="#F44336"
            size="92"
            style="margin-bottom: 15px;"
          >
            mdi-alert-octagon
          </v-icon>
          <div>
            {{ edituser.first_name || edituser.username }} already has an active API token. Resetting the API token will invalidate their current token immediately.
          </div>
        </v-card-text>
        <v-card-actions
          style="background: #F44336; color: white;"
        >
          <v-btn
            dark
            small
            flat
            @click="apiTokenCheck()"
          >
            Generate New API Token
          </v-btn>
          <v-spacer />
          <v-btn
            color="white"
            @click="resetAPITokenDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import Preloader from '@/components/global/Preloader'
import UserActivityLog from './UserActivityLog.vue'
import UserSessionLog from './UserSessionLog.vue'

export default {
  name: 'User',
  props: [ 'id' ],
  components: {
    Preloader,
    UserActivityLog,
    UserSessionLog
  },
  data () {
    return {
      edituser: {},
      editing: true,
      loading: false,
      errorMessages: [],
      saving: false,
      newPassword: null,
      passwordReset: false,
      passwordSaved: false,
      formTagSubs: [],
      contactTagSubs: [],
      tagStatus: '',
      addFormTag: false,
      addContactTag: false,
      filterContactTags: null,
      filterFormTags: null,
      tagFormSearch: null,
      tagContactSearch: null,
      tagSearchStorage: [],
      groups: [],
      groupSearch: '',
      roleSearch: '',
      roles: [],
      showTokenDialog: false,
      APIToken: '',
      tabs: null,
      user: null,
      showForceLogoutDialog: false,
      resetAPITokenDialog: false,
    }
  },
  created () {
    if (this.id !== "new" && this.id !== undefined) {
      this.user = this.id
    } else if (this.$route.params.id !== "new" && this.$route.params.id !== undefined) {
      this.user = this.$route.params.id
    } else {
      this.edituser = {}
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.$route.params.id = to.params.id
    this.user = to.params.id
    next()
  },
  computed: {
    currentUserId() {
      return this.userInfo.id
    },
    tagFormResults () {
      return this.tagSearchStorage.filter(object => {
        var exists = false
        this.formTagSubs.forEach(tagObject => {
          if (tagObject.tag === object) {
            exists = true
          }
        })
        if (!exists) {
          return object
        }
      })
    },
    tagContactResults () {
      return this.tagSearchStorage.filter(object => {
        var exists = false
        this.contactTagSubs.forEach(tagObject => {
          if (tagObject.tag === object) {
            exists = true
          }
        })
        if (!exists) {
          return object
        }
      })
    },
    showCardActions () {
      return this.tabs == 0
    }
  },
  watch: {
    user () {
      if (this.user) {
        this.fetch()
      } else {
        this.edituser = {}
      }
    },
    groupSearch () {
      if (this.groupSearch && this.groupSearch !== "") {
        this.fetchGroups(this.groupSearch)
      }
    },
    tagContactSearch () {
      if (this.tagContactSearch) {
        this.fetchContactTags()
      }
    },
    tagFormSearch () {
      if (this.tagFormSearch) {
        this.fetchFormTags()
      }
    },
    filterFormTags () {
      this.addFormTag = false
      if (this.filterFormTags !== null) {
        this.formTagSubs.push(this.filterFormTags)
        this.tagFormSearch = null
        this.tagSearchStorage = []
        this.filterFormTags = null
      }
    },
    filterContactTags () {
      this.addContactTag = false
      if (this.filterContactTags !== null) {
        this.contactTagSubs.push(this.filterContactTags)
        this.tagContactSearch = null
        this.tagSearchStorage = []
        this.filterContactTags = null
      }
    },
    roleSearch () {
      if (this.roleSearch && this.roleSearch !== "") {
        this.fetchRoles(this.roleSearch)
      }
    }
  },
  methods: {
    apiTokenCheck () {
      if (this.edituser.has_api_token && this.resetAPITokenDialog == false) {
        this.resetAPITokenDialog = true
      } else {
        this.resetAPITokenDialog = false
        this.getAPIToken()
        this.showTokenDialog = true
      }
    },
    fetch () {
      this.loading = true
      api.users.user.get(this.user)
        .then(user => {
          this.documentTitle('User > ' + user.username)
          this.edituser = user
          this.loading = false
          api.userform.adminUserformTags.getSubs(user.id)
            .then(formTags => {
              this.formTagSubs = formTags
            })
          api.userform.adminContactTags.getSubs(user.id)
            .then(contactTags => {
              this.contactTagSubs = contactTags
            })
          if (this.edituser.group)
            api.users.groups.get(this.edituser.group)
              .then((data) => {
                this.groups = [data]
              })
          if (this.edituser.role)
            api.users.roles.get(this.edituser.role)
              .then((data) => {
                this.roles = [data]
              })
        })
    },
    forceLogout () {
      this.loading = true
      api.users.user.logOut(this.edituser.id)
        .then(() => {
          this.loading = false
        })
    },
    fetchRoles (search) {
      api.users.roles.list({
        search: search
      })
      .then((data) => {
        this.roles = data['results']
      })
    },
    resetPassword () {
      api.users.user.resetPassword(this.edituser.id, this.newPassword)
        .then(user => {
          this.loading = false
          this.passwordReset = true
          this.passwordSaved = true
          this.newPassword = user.password
        })
      this.loading = true
    },
    fetchGroups (search) {
      api.users.groups.list({
        search: search
      })
      .then((data) => {
        this.groups = data['results']
      })
    },
    toggleUser () {
      this.loading = true
      this.edituser.is_active = !this.edituser.is_active
      api.users.user.save(this.edituser)
        .then(user => {
          this.loading = false
          this.edituser = user
        })
    },
    save () {
      if (this.$refs.editForm.validate()) {
        this.loading = true
        this.errorMessages = []
        if (!this.edituser.group || this.edituser.is_org_admin)
          this.edituser.group = null
        if (!this.edituser.role)
          this.edituser.role = null
        api.users.user.save(this.edituser, [400])
          .then(user => {
            this.loading = false
            if (!this.edituser.id) {
              this.edituser = user
              this.$router.replace({name: 'OrgEditUser', params: { id: user.id } })
            } else {
              this.closeDialog()
            }
          })
          .catch(error => {
            this.loading = false
            this.saving = false
            if (error.response.status === 400) {
              this.errorMessages = JSON.parse(error.request.response)
            }
          })
      }
    },
    updateFormTag (tag) {
      this.tagStatus = 'saving'
      api.userform.adminUserformTags.updateSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    deleteFormSub (tag) {
      this.tagStatus = 'saving'
      api.userform.adminUserformTags.deleteSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
          this.formTagSubs = this.formTagSubs.filter((oldTag) => {
            if (oldTag !== tag) {
              return oldTag
            }
          })
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    updateContactTag (tag) {
      this.tagStatus = 'saving'
      api.userform.adminContactTags.updateSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    deleteContactSub (tag) {
      this.tagStatus = 'saving'
      api.userform.adminContactTags.deleteSub(this.edituser.id, tag)
        .then(() => {
          this.tagStatus = 'saved'
          this.contactTagSubs = this.contactTagSubs.filter((oldTag) => {
            if (oldTag !== tag) {
              return oldTag
            }
          })
        })
        .catch(() => {
          this.tagStatus = 'error'
        })
    },
    fetchFormTags () {
      api.userform.userformTags.get(this.tagFormSearch)
        .then(tagResults => {
          this.tagSearchStorage = tagResults
        })
    },
    fetchContactTags () {
      api.userform.contactTags.get(this.tagContactSearch)
        .then(tagResults => {
          this.tagSearchStorage = tagResults
        })
    },
    closeDialog () {
      this.$router.push({name: 'OrgUsers' })
    },
    getAPIToken() {
      api.users.user.getAPIToken(this.edituser.id)
        .then(tokenResult => {
          this.APIToken = tokenResult.token
        })
    },
    resetAPIToken() {
      api.users.user.resetAPIToken(this.edituser.id)
        .then(tokenResult => {
          this.APIToken = tokenResult.token
        })
    }
  }
}
</script>

